import React from 'react';

export default function FirstTalkSection() {
  return (
    <section id="first-talk" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0d0a14 0%, #100c1c 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Decorative BG */}
      <div style={{
        position: 'absolute', top: -100, right: -100,
        width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,107,157,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <div style={{
        position: 'absolute', bottom: -100, left: -100,
        width: 300, height: 300, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(168,85,247,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 60, alignItems: 'center',
        }}>
          {/* TEXT SIDE */}
          <div>
            <div className="section-badge">
              <span>💬</span> Chapter 1
            </div>
            <h2 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800,
              fontSize: 'clamp(36px, 6vw, 60px)', lineHeight: 1.15,
              marginBottom: 8,
            }}>
              First <span className="gradient-text">Talk</span>
            </h2>
            <div className="section-divider" />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 18px',
              background: 'rgba(255,107,157,0.08)',
              border: '1px solid rgba(255,107,157,0.2)',
              borderRadius: 50,
              fontFamily: 'Nunito, sans-serif', fontSize: 14,
              color: '#ff6b9d', marginBottom: 24,
            }}>
              📅 12th June 2025
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              Every great love story begins with a single word. On this beautiful day, Hassan and Fiza exchanged their very first words — a simple conversation that neither of them knew would change everything. That first talk was the spark that lit a thousand stars. ✨
            </p>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              In the middle of a regular day, two souls found each other through words. What started as a casual exchange blossomed into something neither could predict — the beginning of a journey worth remembering forever.
            </p>
            <a href="#social-media" className="btn-primary">
              <span>💌</span> Continue Reading
            </a>
          </div>

          {/* ILLUSTRATION SIDE */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              position: 'relative',
              animation: 'float 5s ease-in-out infinite',
            }}>
              <svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 320 }}>
                <defs>
                  <linearGradient id="talkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ff6b9d" />
                    <stop offset="100%" stopColor="#a855f7" />
                  </linearGradient>
                  <filter id="glow">
                    <feGaussianBlur stdDeviation="3" result="blur" />
                    <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
                  </filter>
                </defs>
                {/* BG glow */}
                <circle cx="160" cy="160" r="140" fill="rgba(168,85,247,0.05)" />
                <circle cx="160" cy="160" r="130" fill="none" stroke="rgba(255,107,157,0.1)" strokeWidth="1" strokeDasharray="10 6" />

                {/* Phone shape */}
                <rect x="90" y="60" width="140" height="220" rx="20" fill="#1a1228" stroke="rgba(255,107,157,0.3)" strokeWidth="1.5" />
                <rect x="96" y="70" width="128" height="200" rx="14" fill="#0d0a14" />
                <rect x="130" y="64" width="60" height="6" rx="3" fill="#2d1f4a" />

                {/* Chat bubbles */}
                <rect x="110" y="90" width="85" height="30" rx="12" fill="url(#talkGrad)" opacity="0.9" />
                <text x="152" y="110" textAnchor="middle" fill="white" fontSize="10" fontFamily="Nunito, sans-serif">Hey! 👋</text>

                <rect x="115" y="132" width="90" height="30" rx="12" fill="#2d1f4a" />
                <text x="160" y="152" textAnchor="middle" fill="#e2c8d8" fontSize="9" fontFamily="Nunito, sans-serif">Hii! Kaise ho? 😊</text>

                <rect x="110" y="174" width="80" height="30" rx="12" fill="url(#talkGrad)" opacity="0.9" />
                <text x="150" y="194" textAnchor="middle" fill="white" fontSize="9" fontFamily="Nunito, sans-serif">Main theek! ✨</text>

                <rect x="115" y="216" width="90" height="30" rx="12" fill="#2d1f4a" />
                <text x="160" y="236" textAnchor="middle" fill="#e2c8d8" fontSize="9" fontFamily="Nunito, sans-serif">Mujhe bhi! 💕</text>

                {/* Hearts floating */}
                <text x="60" y="120" fontSize="18" filter="url(#glow)" style={{ animation: 'float 3s ease-in-out infinite' }}>💕</text>
                <text x="255" y="180" fontSize="14" style={{ animation: 'float 4s ease-in-out infinite 1s' }}>✨</text>
                <text x="55" y="230" fontSize="12" style={{ animation: 'float 3.5s ease-in-out infinite 0.5s' }}>🌸</text>
              </svg>

              {/* Date badge */}
              <div style={{
                position: 'absolute', bottom: 10, right: -10,
                background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
                padding: '10px 20px', borderRadius: 50,
                fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 13,
                color: 'white', boxShadow: '0 8px 30px rgba(255,107,157,0.4)',
              }}>
                12 June 2025
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}